<template>
<main class="container-1-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <!-- <h2>Editar usuario</h2> -->
        <TabNav :links="routesNav" @action="onNavAction" />
    </div>

    <div class="container-action">
        
    </div>

    <div class="container-body">
        <label for="firstname">Nombre</label>
        <input id="firstname" v-model="user.firstname" type="text" :maxlength="textInputMaxLength"
        name="nombre" :class="{'error' : errors.has('nombre') }" v-validate="'required|max:' + textInputMaxLength"
        :placeholder="[[errors.has('nombre') ? errors.first('nombre') : 'Ingresa el nombre']]"/>

        <label for="lastname">Apellidos</label>
        <input id="lastname" v-model="user.lastname" type="text" :maxlength="textInputMaxLength"
        name="apellidos" :class="{'error' : errors.has('apellidos') }" v-validate="'required|max:' + textInputMaxLength"
        :placeholder="[[errors.has('apellidos') ? errors.first('apellidos') : 'Ingresa los apellidos']]"/>

        <label for="group">Grupos del usuario</label>
        <div id="group" :class="{'error': groupError}">
            <div class="group-chips" v-if="user.id_groups.length">
                <span class="group-chip" v-for="idGroup in user.id_groups" v-bind:key="idGroup">
                    {{groupNameById(idGroup)}}
                    <button type="button" class="group-chip-remove" v-on:click="removeGroup(idGroup)">×</button>
                </span>
            </div>
            <select v-model="groupToAdd" v-on:change="addGroup()">
                <option value="" disabled selected>Selecciona un grupo</option>
                <option
                v-for="item in availableGroups"
                v-bind:key="item.index"
                v-bind:value="item.id">
                {{item.name}}
                </option>
            </select>
        </div>

        
        <label for="username">Correo electrónico</label>
        <input id="username" v-model="user.username" type="text" :maxlength="textInputMaxLength"
        name="nombre de usuario" :class="{'error' : errors.has('nombre de usuario') }" v-validate="'required|email|max:' + textInputMaxLength + '|unique'"
        :placeholder="[[errors.has('nombre de usuario') ? errors.first('nombre de usuario') : 'Escribe el nombre de usuario']]"/>

        <label for="login">Login (opcional)</label>
        <input id="login" v-model="user.login" type="text"
        name="login" :class="{'error' : errors.has('login') }" v-validate="'min:3|unique_login'"
        :placeholder="[[errors.has('login') ? errors.first('login') : 'Mínimo 3 caracteres']]"/>
        <p class="field-note">Se respetan exactamente las mayúsculas y minúsculas ingresadas.</p>

        <label for="region">Región</label>
        <select id="region" v-model="user.region" name="región"
        :class="{'error' : errors.has('región') }" v-validate="'required'">
            <option value="">Selecciona una región</option>
            <option v-for="item in regiones" v-bind:key="item" v-bind:value="item">{{item}}</option>
        </select>

        <label for="genero">Género</label>
        <select id="genero" v-model="user.genero" name="género"
        :class="{'error' : errors.has('género') }" v-validate="'required'">
            <option value="">Selecciona un género</option>
            <option v-for="item in generos" v-bind:key="item" v-bind:value="item">{{item}}</option>
        </select>

        <label for="cargo">Cargo</label>
        <input id="cargo" v-model="user.cargo" type="text" name="cargo" :maxlength="textInputMaxLength"
        :class="{'error' : errors.has('cargo') }" v-validate="'required|max:' + textInputMaxLength"
        :placeholder="[[errors.has('cargo') ? errors.first('cargo') : 'Ingresa el cargo']]"/>

        <label for="telefono">Teléfono (opcional)</label>
        <input id="telefono" v-model="user.telefono" type="text" name="telefono" :maxlength="textInputMaxLength"
        :class="{'error' : errors.has('telefono') }" v-validate="'max:' + textInputMaxLength"
        :placeholder="[[errors.has('telefono') ? errors.first('telefono') : 'Ingresa el teléfono']]"/>

        <label for="es_externo">Tipo de usuario</label>
        <div id="es_externo">
            <input type="checkbox" id="checkbox-es-externo" v-model="user.es_externo" v-on:change="syncInstitutionWithUserType()">
            <label for="checkbox-es-externo">Usuario externo</label>
        </div>

        <template v-if="user.es_externo">
            <label for="institucion">Institución</label>
            <input id="institucion" v-model="user.institucion" type="text" :maxlength="textInputMaxLength"
            name="institución" :class="{'error' : errors.has('institución') }" v-validate="'required|max:' + textInputMaxLength"
            :placeholder="[[errors.has('institución') ? errors.first('institución') : 'Ingresa la institución']]"/>
        </template>

        <label for="permissions">Permisos de usuario</label>
        <div id="permissions">
                <!--Nombres nuevos segun observacion de SENAPRED 06/2026 ("1. En la creación y en la edición, el nombre de los permisos debe ser el mismo que aparece en ver usuarios.")-->
                <!--Se elimina geoprocesos porque la vista asociada esta deshabilitada (revision SENAPRED 06/2026)-->
            <input v-if="user.permissions" type="checkbox" id="checkbox-acceso-visor" v-model="user.permissions.visor">
            <label for="checkbox-acceso-visor">Acceso al visor</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox-administracion-usuarios" v-model="user.permissions.users">
            <label for="checkbox-administracion-usuarios">Administración de usuarios</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox-administracion-capas" v-model="user.permissions.layers">
            <label for="checkbox-administracion-capas">Administración de capas</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox-administracion-mapas" v-model="user.permissions.maps">
            <label for="checkbox-administracion-mapas">Administración de mapas</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox-administracion-documentos" v-model="user.permissions.documents">
            <label for="checkbox-administracion-documentos">Administración de documentos</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox-administracion-instructivos" v-model="user.permissions.wiki">
            <label for="checkbox-administracion-instructivos">Administración de instructivos</label>
            <br>
            <input v-if="user.permissions" type="checkbox" id="checkbox-acceso-monitoreo" v-model="user.permissions.monitoring">
            <label for="checkbox-acceso-monitoreo">Administración de monitoreo</label>
            <br>
            <input v-if="user.permissions && user.permissions.terrain" type="checkbox" id="checkbox-terreno-gestion" v-model="user.permissions.terrain.manage">
            <label for="checkbox-terreno-gestion">Gestión de terreno</label>
            <br>
            <input v-if="user.permissions && user.permissions.terrain" type="checkbox" id="checkbox-terreno-respuesta" v-model="user.permissions.terrain.respond">
            <label for="checkbox-terreno-respuesta">Respuesta de terreno</label>
            <br>
            <input v-if="user.permissions && user.permissions.terrain" type="checkbox" id="checkbox-terreno-revision" v-model="user.permissions.terrain.review">
            <label for="checkbox-terreno-revision">Revisión de terreno</label>
            <br>
            <input v-if="user.permissions && user.permissions.terrain" type="checkbox" id="checkbox-terreno-publicacion" v-model="user.permissions.terrain.publish">
            <label for="checkbox-terreno-publicacion">Publicación de terreno</label>
        </div>

        <label for="status">Estado</label>
        <div id="status">
            <input type="checkbox" id="checkbox-status" v-model="statusActivo" :disabled="isSelf">
            <label for="checkbox-status">Activo</label>
        </div>

        <div class="container-action-left" style="justify-content: start;">
            <button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
            <button class="btn btn-secondary" v-on:click="onClickGoNext()">Actualizar usuario</button>
        </div>

        <div v-if="errors.any() || validationMessage" class="validation-summary">
            <div v-if="validationMessage" class="validation-summary__message">
                {{ validationMessage }}
            </div>
            <div
                v-for="error in errors.items" :key="error.id" class="validation-summary__error"
            >
                {{ error.msg }}
            </div>
        </div>

    </div>

    <div class="container-list"> 
        
    </div>
 
    <UserDeleteModal
      v-if="showDeleteModal"
      :userId="$route.params.idUser"
      :userName="deleteModalUserName"
      @close="closeDeleteModal"
      @deleted="onUserDeleted"
    />

</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'

import {restUser} from '@/components/mixin/restUser.js'
import {restGroup} from '@/components/mixin/restGroup.js'
import { userDeleteModal } from '@/components/mixin/userDeleteModal.js'

export default{
    name: 'test',
    mixins: [restUser, restGroup, userDeleteModal],
    data(){
        return{
            actualUsername: '',
            deletePressed: false,
            originalStatus: true,
            myId: '',
            groupError: false,
            groupToAdd: '',
            validationMessage: '',
            textInputMaxLength: 30
        }
    },
    components:{
        Breadcrumb,
        TabNav
    },
    computed: {
        routesNav: function(){
          return [
                {name:'Resumen' , path: '/usuarios/' + this.$route.params.idUser, exact: true},
                {name:'Editar usuario' , path: '/usuarios/' + this.$route.params.idUser + '/editar-usuario'},
                {name:'Asignar mapas' , path: '/usuarios/' + this.$route.params.idUser + '/asignar-mapas'},
                {name:'Crear contraseña temporal' , path: '/usuarios/' + this.$route.params.idUser + '/contrasena-temporal'},
                {name:'Historial de cambios' , path: '/usuarios/' + this.$route.params.idUser + '/historial-de-cambios'},
                {name:'Eliminar usuario' , action: 'delete'}
              ]
        },
        routesBread: function(){
          return [
              {name:'Usuarios', path: '/usuarios' },
              {name: this.user.firstname + ' ' + this.user.lastname, path: '/usuarios/' + this.$route.params.idUser},
              {name: 'Editar usuario'}
              ]
        },
        availableGroups: function(){
            return this.groups.filter((item) => !this.user.id_groups.includes(item.id))
        },
        //null/undefined = activo (backwards-compat con usuarios sin campo status)
        statusActivo: {
            get() { return this.user.status !== false },
            set(value) { this.$set(this.user, 'status', value) }
        },
        isSelf: function(){
            return this.user.id === this.myId
        }
    },
    props: [],
    methods:{
        onClickGoBack: function() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/usuarios/' + this.$route.params.idUser)
        },
        groupNameById: function(idGroup) {
            const group = this.groups.find((item) => item.id === idGroup)
            return group ? group.name : 'Grupo desconocido'
        },
        addGroup: function() {
            if (this.groupToAdd) {
                this.user.id_groups.push(this.groupToAdd)
                this.groupToAdd = ''
            }
        },
        removeGroup: function(idGroup) {
            this.user.id_groups = this.user.id_groups.filter((item) => item !== idGroup)
        },
        onClickGoNext: function() {
            this.groupError = this.user.id_groups.length === 0;
            if (this.groupError) {
                this.validationMessage = 'Selecciona al menos un grupo para el usuario.';
                return;
            }

            const that = this;
            this.$validator.validateAll()
            .then(function (response) {
                if(response) {
                    that.validationMessage = '';
                    const newStatus = that.user.status !== false;
                    if (newStatus !== that.originalStatus) {
                        //Cambio de estado requiere confirmación antes de guardar
                        const action = newStatus ? 'activar' : 'inactivar';
                        const fullname = that.user.firstname + ' ' + that.user.lastname;
                        that.$modal.show('dialog', {
                            text: '¿Desea ' + action + ' al usuario "' + fullname + '"?',
                            buttons: [
                                { title: 'No' },
                                {
                                    title: 'Sí',
                                    handler: () => {
                                        that.$modal.hide('dialog');
                                        that.putUserStatus(newStatus)
                                            .then(() => { that.putUser(); })
                                            .catch((error) => {
                                                console.log(error);
                                                that.message = error.response.data.message;
                                            });
                                    }
                                }
                            ]
                        });
                    } else {
                        that.putUser();
                    }
                } else {
                    that.validationMessage = 'Hay errores en el formulario. Revise los campos marcados.';
                }
            })
            .catch(function (error) {
                that.validationMessage = 'Ocurrió un error inesperado';
                console.error(error);
            })
        }
    },
    updated () {

    },
    created () {
        //Verificar permisos
        this.$store.getters.getPermissions.users? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getGroupsNoPages();
        this.getUser().then(() => {
            this.originalStatus = this.user.status !== false;
            //Usuarios legacy pueden venir con id_groups null
            if (!this.user.id_groups) {
                this.$set(this.user, 'id_groups', []);
            }
            //Usuarios legacy pueden no tener aún el bloque permissions.terrain
            if (this.user.permissions && !this.user.permissions.terrain) {
                this.$set(this.user.permissions, 'terrain', {
                    manage: false,
                    respond: false,
                    review: false,
                    publish: false
                });
            }
            //El backend omite wiki cuando es false (omitempty): sin esta base
            //el checkbox quedaría ligado a una propiedad no reactiva
            if (this.user.permissions && this.user.permissions.wiki === undefined) {
                this.$set(this.user.permissions, 'wiki', false);
            }
        });

        //Id del usuario logueado para deshabilitar el checkbox de estado propio
        this.$http.get(this.$store.getters.backendurl + 'api/v1/accounts/me')
            .then((response) => { this.myId = response.data.id })
            .catch((error) => { console.log(error) });

        //Verificar username único en servidor
        const isUnique = (value) => {
            const that = this;
            return this.$http.post(this.$store.getters.backendurl + 'api/v1/accounts/check', {username: value})
            .then(function (response) {
                if (that.actualUsername == value) {
                    return {
                        valid: true,
                        data: {
                            message: "Es el mismo correo ya registrado"
                        }
                    };
                }
                return {
                    valid: response.data.valid,
                    data: {
                        message: response.data.message
                    }
                };
            })
            .catch(function (error) {
                console.log(error);
                return {
                    valid: false,
                    data: {
                        message: "No se puede verificar"
                    }
                }
            });
        };
        this.$validator.extend('unique', {
            validate: isUnique,
            getMessage: (field, params, data) => {
                return data.message;
            }
        });

        const isLoginUnique = (value) => {
            return this.$http.post(this.$store.getters.backendurl + 'api/v1/accounts/check-login', {
                login: value,
                exclude_id: this.$route.params.idUser
            })
            .then((response) => ({
                valid: response.data.valid,
                data: { message: response.data.message }
            }))
            .catch((error) => {
                console.log(error);
                return { valid: false, data: { message: 'No se puede verificar el login' } };
            });
        };
        this.$validator.extend('unique_login', {
            validate: isLoginUnique,
            getMessage: (field, params, data) => data.message
        });
    }
}
</script>

<style lang="scss" scoped>
.field-note {
    margin: 4px 0 12px;
    font-size: 12px;
    color: #5f6b7a;
}

.group-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.group-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.25rem 0.5rem;
    border-radius: 999px;
    background-color: #e9ecef;
    font-size: 0.85em;
}

.group-chip-remove {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 1em;
    line-height: 1;
    padding: 0;
}

.validation-summary {
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #dc3545;
    border-radius: 4px;
    background-color: #fff5f5;
}

.validation-summary__message {
    color: #dc3545;
    font-weight: 600;
    margin-bottom: 0.75rem;
}

.validation-summary__error {
    color: #dc3545;
    line-height: 1.5;
}

.validation-summary__error:not(:last-child) {
    margin-bottom: 0.25rem;
}
</style>
